var buttonTypeData = ['link', 'anchor', 'button'];
export default buttonTypeData;